import { render, staticRenderFns } from "./MobileAppFaq.vue?vue&type=template&id=c15b8b06&"
import script from "./MobileAppFaq.vue?vue&type=script&lang=js&"
export * from "./MobileAppFaq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports